<template>
  <span>
    <slot name="default"></slot>{{ loadingDots }}
  </span>
</template>
<script>
export default {
  name: 'sui-loading-text',

  props: {
    wait: {
      type: Number,
      default: 200
    }
  },

  data: function () {
    return {
      dots: 1
    }
  },

  computed: {
    loadingDots: function () {
      return `${'.'.repeat(this.dots)}${' '.repeat(4 - this.dots)}`
    }
  },

  methods: {
    updateDots: function () {
      ++this.dots
      if (this.dots === 5) {
        this.dots = 1
      }
      setTimeout(() => { this.updateDots() }, this.wait)
    }
  },

  mounted: function () {
    this.updateDots()
  }
}
</script>
<style scoped>
</style>
